/*
 * (c) Copyright, 2008-2015 Massachusetts Institute of Technology.
 *
 *     This material may be reproduced by or for the
 *     U.S. Government pursuant to the copyright license
 *     under the clause at DFARS 252.227-7013 (June, 1995).
 */
define(['ext', 'hvx/modules/CoreModule', 'hvx/modules/Constants'], (Ext, Core, Constants) => {

  return Ext.define('map.HoverListener', {

    constructor: function(renderers) {
      this.renderers = renderers;

      this.container = new Ext.tip.ToolTip({
        anchor: 'left',
        constrain: true,
        constrainTo: 'cMainComponent-body',
        constraintInsets: '0 60 0 0',
        maxWidth: 250,
        showDelay: 0
      });

      this.olMap = Core.Ext.Map.getMap();
      this.olMap.on('pointermove', this.onMapPointerMove.bind(this));
    },

    addRenderer: function(renderer) {
      // add newer renderers to front of array
      this.renderers.unshift(renderer);
    },

    onWindowClose: function() {
      this.cleanup();
    },

    onMapPointerMove: function(evt) {
      const map = evt.map;
			
      // toggle dragging cls for cursor feeedback
      if (evt.dragging && !this.dragging) {
        this.dragging = true;
        Ext.fly(map.getTarget()).addCls('ol-dragging');
				
        //hide tooltip on drag start
        this.container.hide();
      } else if (!evt.dragging && this.dragging) {
        this.dragging = false;
        Ext.fly(map.getTarget()).removeCls('ol-dragging');
      }
			
      // skip tooltip logic during drag
      if (this.dragging) {
        return;
      }

      const pixel = map.getEventPixel(evt.originalEvent);
      const features = this.getFeaturesAtPixel(map, pixel);
      const hoverLayer = this.hasHoverLayerAtPixel(map, pixel);
      const overFeatures = features.length || hoverLayer;
      let handled = false;
			
      // toggle hover cls for cursor feeedback
      if (overFeatures) {
        if (!this.hovering) {
          this.hovering = true;
          Ext.fly(map.getTarget()).addCls('ol-hover-feature');
        }
				
        if(features.length) {
          handled = this.render(features);
        } else if (hoverLayer) {
          handled = this.renderRainfallLayer(this.container, map, hoverLayer, pixel);
        }
      } else if (this.hovering) {
        this.hovering = false;
        Ext.fly(map.getTarget()).removeCls('ol-hover-feature');
      }
				
      if (handled && this.hasTooltipContent()) {
        this.container.showAt([
          evt.originalEvent.clientX + 15,
          evt.originalEvent.clientY + 15
        ]);
      } else {
        this.container.hide();
      }
    },

    hasTooltipContent: function() {
      if (this.container.html && this.container.html.trim().length > 0) {
        return true;
      }
      const el = this.container.getEl();
      if (!el) {
        return false;
      }
      return el.dom.textContent.trim().length > 0;
    },

    renderRainfallLayer: function(container, map, layer, pixel) {
      if (layer.get('metadata') && layer.get('metadata').type === 'qpe') {
        const precipitation = this.getObservedRainValue(map,layer, pixel);
        if (precipitation && precipitation.title && String(precipitation.title).trim()) {
          container.setHtml(precipitation.title);
          return true;
        }
      }
      return false;
    },

    getObservedRainValue: function(map,layer, pixel) {	
      const ogOpacity = layer.getOpacity();
      layer.setOpacity(1);
      layer.changed();

      // Force render to apply opacity change
      map.renderSync();
      map.renderSync();
	
      // Get RGBA from canvas at full opacity
      const rgba = this.getPixelRGBA(map, pixel);
      const rgbKey = `${rgba[0]},${rgba[1]},${rgba[2]}`;
      const legend = layer.get('legend');

      let match;
      if (legend.name === 'legend-observed-rain-hrs') {
        match = Constants.rainHrsColorMap[rgbKey];
      } else if (legend.name === 'legend-observed-rain-days') {
        match = Constants.rainDaysColorMap[rgbKey];
      }
	
      layer.setOpacity(ogOpacity);
      layer.changed();
      map.renderSync();
	
      return match;
    },

    getPixelRGBA: function(map, pixel) {
      const canvas = map.getTargetElement().querySelector('canvas');
      const ctx = canvas.getContext('2d');
      const imageData = ctx.getImageData(pixel[0], pixel[1], 1, 1);
      return imageData.data;
    },

    render: function(features) {
      //clear the container before rendering
      this.container.removeAll();

      return this.delegateRender(this.container, features);
    },

    delegateRender: function(container, features) {
      // run every feature through every renderer until one handles
      return features.some(function(feature) {
        return this.renderers.some((renderer) => {
          return renderer.render.call(renderer, container, feature);
        });
      }, this);
    },

    getFeaturesAtPixel: function(map, px) {
      const features = [];
      map.forEachFeatureAtPixel(px, (feature, layer) => {
        features.push(feature);
      });
      return features;
    },
		
    hasHoverLayerAtPixel: function(map, px) {
      return map.forEachLayerAtPixel(px, (layer) => {
        // stop iteration on first match
        return layer;
      }, {
        layerFilter: function(layer) {
          // filter layers to those marked clickable
          return layer.get('hoverable') === true;
        }
      });
    }
  });
});
